import { MaydayAxiosInstance } from '@getmayday/mayday-api-instances';

export default function (tokenService: any) {
  const options =
    process.env.NODE_ENV === 'development'
      ? {
          commonHeaders: {
            [import.meta.env.VITE_APP_CORS_LOCAL_HEADER as string]: import.meta
              .env.VITE_APP_CORS_LOCAL_SECRET,
          },
        }
      : { commonHeaders: {} };

  options.commonHeaders['x-client-origin'] = 'CHROME_EXT';
  const maydayAxiosInstance = new MaydayAxiosInstance(tokenService, options);

  return {
    authClient: maydayAxiosInstance.create(
      `${import.meta.env.VITE_APP_SSO_URL}/`,
    ),
    adminClient: maydayAxiosInstance.create(
      `${import.meta.env.VITE_APP_BACK_URL}/integration`,
    ),
    knowledgeClient: maydayAxiosInstance.create(
      `${import.meta.env.VITE_APP_MONGO_BACK_URL}/integration`,
    ),
    notificationClient: maydayAxiosInstance.create(
      `${import.meta.env.VITE_APP_NOTIFICATIONS_URL}/api`,
    ),
    brainClient: maydayAxiosInstance.create(
      `${import.meta.env.VITE_APP_BRAIN_URL}/api`,
    ),
    eventClient: maydayAxiosInstance.create(
      `${import.meta.env.VITE_APP_BACK_URL}/knowledge/events`,
    ),
  };
}
